import { Modal } from '@/components/Layout';
import { Button, TextField } from '@/components/Common';
import { TextfieldType } from '@/components/Common/TextField/TextField.types';
import { useFaqList } from './FaqList.hook';
import { FieldError } from 'react-hook-form';

const AddNewFaq = () => {
  const {
    isOpenModal,
    setIsOpenModal,
    handleSubmitFaqByCategory,
    registerFaqByCategory,
    handleCreateFaqByCategory,
    errorsFaqByCategory,
    isCreatingFaqByCategory,
  } = useFaqList();

  return (
    <Modal
      isOpen={isOpenModal}
      onClose={() => setIsOpenModal(false)}
      modalStyle="bg-[#2A2A2A] w-[375px] h-[246px]"
      headerStyle="bg-[#2A2A2A]"
    >
      <div className="flex items-center justify-center w-full fex flex-col px-4">
        <h3 className="text-white text-center text-xl font-bold leading-[normal] tracking-[0.4px] font-raleway">
          Ajouter une catégorie FAQ
        </h3>
        <form
          className="mt-9 flex flex-col gap-4 w-full"
          onSubmit={handleSubmitFaqByCategory(handleCreateFaqByCategory)}
        >
          <TextField
            inputStyle={{ background: '#1D1D1D' }}
            name="topic"
            register={registerFaqByCategory('name')}
            textFieldType={TextfieldType.INPUT}
            placeholder="Nom de catégorie"
            errorStyle="text-red-500"
            helpText={(errorsFaqByCategory.name as FieldError)?.message}
          />
          <Button type="submit" title={`${isCreatingFaqByCategory ? 'Ajout en cours...' : 'Ajouter'}`} className="w-full" />
        </form>
      </div>
    </Modal>
  );
};

export default AddNewFaq;
